import * as Api from "@api";
import * as C from "@components";
import * as P from "@parts";

export const SimilarProductsSectionKeys = [
    "similar-section.title",
] as const;

export type SimilarProductsSectionProps = {
    productSlug: string;
    pageContent: Api.Content<typeof SimilarProductsSectionKeys[number]>;
};

export async function SimilarProductsSection({productSlug, pageContent}: SimilarProductsSectionProps) {
    const products = await Api.ProductService.getSimilarContent(productSlug)

    return products.length > 0 &&
        <C.PageSection>
            <C.PageContent
                {...pageContent['similar-section.title']}
                typography={C.Typography.H2}
                margins={{bottom: C.Margin.D40}}
                centered
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {products.map((product) => (
                    <P.ProductCard key={product.id} product={product}/>
                ))}
            </div>
        </C.PageSection>
}